import { render, staticRenderFns } from "./ArgesTarjetasAgregarFotos.vue?vue&type=template&id=792c5dfd&scoped=true&"
import script from "./ArgesTarjetasAgregarFotos.vue?vue&type=script&lang=ts&"
export * from "./ArgesTarjetasAgregarFotos.vue?vue&type=script&lang=ts&"
import style0 from "./ArgesTarjetasAgregarFotos.vue?vue&type=style&index=0&id=792c5dfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c5dfd",
  null
  
)

export default component.exports